import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function TransitionDownIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <>
        <path d="M16.293 12.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L12 16.586z" />
        <path
          d="M16.293 5.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L12 9.586z"
          opacity={0.6}
        />
      </>
    </Icon>
  );
}

TransitionDownIcon.displayName = 'TransitionDownIcon';
